<template>
  <div class="admin-users">
    <page-title title="筛选">
      <el-row :gutter="20" class="admin-users__filter-header">
        <el-col :xl="3" :span="6">
          <span>用户ID：</span>
          <el-input v-model="filter.userId" placeholder="请输入"></el-input>
        </el-col>
        <el-col :xl="3" :span="6">
          <span>用户名：</span>
          <el-input v-model="filter.nickname" placeholder="请输入"></el-input>
        </el-col>
        <el-col :xl="3" :span="6">
          <span>注册手机号：</span>
          <el-input v-model="filter.mobile" placeholder="请输入"></el-input>
        </el-col>
        <el-col :xl="4" :span="6">
          <span>认证状态：</span>
          <el-select clearable v-model="filter.state" placeholder="请选择">
            <el-option v-for="s in STATUS" :label="STATUS_zh[s]" :value="s" :key="s"></el-option>
          </el-select>
        </el-col>
        <el-col :xl="4" :span="6">
          <span>认证类型：</span>
          <el-select clearable v-model="filter.type" placeholder="请选择">
            <el-option v-for="t in TYPE" :label="TYPE_zh[t]" :value="t" :key="t"></el-option>
          </el-select>
        </el-col>
        <el-col :xl="4" :span="6">
          <span>启/禁用：</span>
          <el-select clearable v-model="filter.enabled" placeholder="请选择">
            <el-option :value="true" label="启用"></el-option>
            <el-option :value="false" label="禁用"></el-option>
          </el-select>
        </el-col>
        <el-col :xl="3" :span="6">
          <el-button @click="getList">查询</el-button>
          <el-button @click="filter = {};getList()">重置</el-button>
        </el-col>
      </el-row>
    </page-title>
    <page-title title="数据列表">
      <div class="admin-users__body">
        <el-table :data="usersData" style="width: 100%" :header-cell-style="{ backgroundColor: `#f7f7f7` }" v-loading="loading">
          <el-table-column type="index" width="50" align="center"> </el-table-column>
          <el-table-column prop="userId" label="用户ID" width="160"> </el-table-column>
          <el-table-column prop="username" label="用户名" width="170"> 
            <template slot-scope="{ row }">
              {{ row.certification?row.certification.realName:''}}
            </template>
          </el-table-column>
          <el-table-column prop="profile.nickname" label="昵称" width="170"> </el-table-column>
          <el-table-column prop="mobile" label="注册手机号" width="170"> </el-table-column>
          <el-table-column prop="email" label="邮箱" width="170"> </el-table-column>
          <el-table-column label="认证状态" width="140">
            <template slot-scope="{ row }">
              <user-state-label :status="row.state"></user-state-label>
            </template>
          </el-table-column>
          <el-table-column label="认证类型" width="145">
            <template slot-scope="{ row }">
              {{ TYPE_zh[row.type] }}
            </template>
          </el-table-column>
          <!-- <el-table-column prop="num" label="购买商品数量" width="155"> </el-table-column> -->
          <el-table-column label="启/禁用状态" width="120">
            <template slot-scope="{ row }">
              <el-switch :value="row.enabled" :active-text="row.enabled ? '启用' : '禁用'" active-color="#005bff" inactive-color="#dadde0">
              </el-switch>
            </template>
          </el-table-column>
          <el-table-column prop="createdDate" label="注册时间" width="180"> </el-table-column>
          <el-table-column label="操作" fixed="right" min-width="100">
            <template slot-scope="{ row }">
              <router-link style="text-decoration:none;color:#005BFF;" :to="`/users/${row.id}/${row.userId}`">
                <span>详情</span>
              </router-link>
            </template>
          </el-table-column>
        </el-table>
        <cus-pagination :total="total" :current-page.sync="currentPage" :page-size.sync="pageSize" @size-change="getList"></cus-pagination>
      </div>
    </page-title>
  </div>
</template>
<script>
import PageTitle from '@/components/pageTitle.vue';
import CusPagination from '@/components/cusPagination.vue';
import UserStateLabel from './components/userStateLabel';
import { getUserList } from '@/api/req';
import { TYPE, TYPE_zh, STATUS, STATUS_zh } from './_eum';

export default {
  name: 'users',
  components: {
    PageTitle,
    CusPagination,
    UserStateLabel
  },
  data() {
    return {
      filter: {},
      usersData: [],
      currentPage: 1,
      pageSize: 10,
      total: 0,
      loading: true
    };
  },
  computed: {
    TYPE: () => TYPE,
    TYPE_zh: () => TYPE_zh,
    STATUS: () => STATUS,
    STATUS_zh: () => STATUS_zh
  },
  watch: {
    currentPage() {
      this.getList();
    }
  },
  methods: {
    getList() {
      this.loading = true;
      const req = {
        pageSize: this.pageSize,
        pageNumber: this.currentPage,
        ...this.filter
      };
      this.$ajax
        .get(getUserList, req)
        .then(({ data }) => {
          this.total = data.total;
          this.usersData = Object.freeze(data.rows);
          this.loading = false;
        })
        .catch(err => {
          console.log('err.data :>> ', err.data);
          this.loading = false;
        });
    }
  },
  created() {
    const { query } = this.$route;
    if (JSON.stringify(query) !== '{}') {
      this.filter = Object.assign(this.filter, query);
    }
    this.getList();
  }
};
</script>

<style lang="scss">
.admin-users {
  &__body {
    .el-table {
      border: 1px solid #ebeef5;
      border-bottom: none;
      margin-bottom: 20px;
    }
    .el-switch__label {
      color: #8998a0;
    }
    .el-switch__label.is-active {
      color: #005bff;
    }
  }
}
</style>
